import { Component, OnInit, Input, OnChanges, OnDestroy, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { UtilsService } from 'src/app/utils/utils.service';
import { Router, ActivatedRoute } from '@angular/router';
import { WindspeedService } from './windspeed/windspeed.service';
import { DeviceDetectorService } from 'ngx-device-detector';
// import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-extreme-weather',
  templateUrl: './extreme-weather.component.html',
  styleUrls: ['./extreme-weather.component.scss']
})
export class ExtremeWeatherComponent implements OnInit, OnDestroy, OnChanges {
  @Input() blockNum: number;
  @Output() posNum = new EventEmitter<any>();
  buttonClickedArray: any;
  selectedWindSpeed: any;
  selectedHumidity: any;
  selectedRainfall: any;
  selectedTemperature: any;
  forecastLengthSubscription: any;
  blockArraySubscription: any;
  six_hour_blocks: any;
  selected: string;
  selectedBlock: any;
  adminSelected: any = true;
  forecastLength: any;
  imdSRLR: any;
  disableSRLRToggle: any;
  stateUrlId: any;
  timeStampList: {};
  minMax: any;
  sourceDropdown = ['IMD'];
  selectedvalue: any = 'IMD';
  activeRadioList: boolean[] = [];
  detEnsmbl = '';
  meanMedian ='';
  forecastLengthOtherThanRainfall: any;
  sourceList: any;
  sourceListSubscription: any;
  selectedComponent: string;
  deviceInfo: any;
  lang: string;
  constructor(private utils: UtilsService, private router: Router, private route: ActivatedRoute, private windService: WindspeedService, private deviceService: DeviceDetectorService,) {
    for (const key in ProjConstants.IDTOUUIDMAPPING) {
      if (!ProjConstants.IDTOUUIDMAPPING.hasOwnProperty(this.route.snapshot.paramMap.get('id'))) {
        router.navigate(['*']);
      }
    }
    this.stateUrlId = this.route.snapshot.paramMap.get('id');
    ProjConstants.STATENAME = this.utils.getStateName(this.stateUrlId);

    this.deviceInfo = this.deviceService.getDeviceInfo();
    // console.log("device!!!!!!!", this.deviceInfo)

    this.selectedComponent = router.url.split('/')[1];

    this.imdSRLR = false;
    this.disableSRLRToggle = false;

    const temp = this.utils.getAdminBasinToggle().subscribe(
      data => {
        this.adminSelected = data;
      });
    temp.unsubscribe();
    const temp1 = this.utils.getIdmEcmwf().subscribe(
      data => {
        this.selectedvalue = data;
      });
    temp1.unsubscribe();
    this.utils.setSRLRToggle(this.imdSRLR);

    this.buttonClickedArray = [true, false, false, false];
    this.selectedWindSpeed = true;
    this.selectedHumidity = false;
    this.selectedRainfall = false;
    this.selectedTemperature = false;

    this.forecastLengthSubscription = this.utils.getForecastLengthChanged().subscribe(value => {

      // if (this.selected !== 'rainfall') {
      //   this.sourceDropdown = ['IMD'];
      //   this.selectedvalue = 'IMD';
      // } else {
      //   if (value.toString() === 'weekly') {
      //     this.sourceDropdown = ['ECMWF'];
      //   }
      //   else{
      //     this.sourceDropdown = ['ECMWF','IMD'];
      //   }
      // }
      this.forecastLength = value;

      this.forecastLengthOtherThanRainfall = this.forecastLength;
      if (this.forecastLength === 'weekly') {
        this.forecastLengthOtherThanRainfall = '10';
      }
      if (this.forecastLength != null) {
      }
      if (this.forecastLength == '10') {
        this.disableSRLRToggle = true;

        this.imdSRLR = false;
      }else if(this.forecastLength == 'weekly'){

      }else {
        this.disableSRLRToggle = false;
        this.imdSRLR = true;
      }
      this.updateSourceDropDown();
    });

  }

  @Input() labelStrings: any;

  ngOnInit() {
    this.lang = localStorage.getItem("lang");
    // this.translate.use(this.lang.match(/en|te|hi/) ? this.lang : 'en');
    // setTimeout(() => {
    //   window.location.reload();
    // }, 900000);
    // this.reloadFunction();
    this.deviceInfo = this.deviceService.getDeviceInfo();
    // console.log("device!!!", this.deviceInfo)
    this.forecastLength = this.route.snapshot.paramMap.get('time');

    // this.createlabelStrings();
    this.forecastLengthOtherThanRainfall = this.forecastLength;
    const url = this.router.url;
    const urlparams = url.split('/', 10);
    this.selected = urlparams[2];
    this.forecastLengthOtherThanRainfall = this.forecastLength;
    if (this.forecastLength === 'weekly') {
      this.forecastLengthOtherThanRainfall = '10';
    }
    this.sourceListSubscription = this.utils.getExtremeWeatherSourceList().subscribe(data => {
        if(this.sourceList == undefined && this.sourceList != data){
          this.sourceList = data;
          this.updateSourceDropDown();
          // this.updateSourceSelected();
        }
    });
    // if (this.selected !== 'rainfall') {
    //   this.sourceDropdown = ['IMD'];
    //   this.selectedvalue = 'IMD';
    // } else {
    //   this.selectedvalue = 'ECMWF';
    //   if (this.forecastLength === 'weekly') {
    //     this.sourceDropdown = ['ECMWF'];
    //     this.forecastLengthOtherThanRainfall = '10';
    //   }
    //   else{
    //     this.sourceDropdown = ['ECMWF','IMD'];
    //   }
    // }

    // this.utils.setImdEcmwf(this.selectedvalue);
    this.selectedvalue = this.utils.getIdmEcmwfValue();
    this.six_hour_blocks = ProjConstants.SIXHOURBLOCKS;
    const minMaxSubscription = this.utils.minMax.subscribe(value => {
      this.minMax = value;
    });
    minMaxSubscription.unsubscribe();
    this.blockArraySubscription = this.utils.getBlocksArray().subscribe(value => {
      this.six_hour_blocks = value;
    });
    if (this.forecastLength === '24') {
      if (this.router.url.split('/')[2] === 'windspeed') {
        for (let i = 0; i < 28; ++i) {
          if (i === this.blockNum) {
            this.activeRadioList.push(true);
          } else {
            this.activeRadioList.push(false);
          }
        }
      } else if (this.router.url.split('/')[2] === 'rainfall' || this.router.url.split('/')[2] === 'temperature' ||
        this.router.url.split('/')[2] === 'humidity') {
        for (let i = 0; i < 9; ++i) {
          if (i === this.blockNum) {
            this.activeRadioList.push(true);
          } else {
            this.activeRadioList.push(false);
          }
        }
      }
    } else if (this.forecastLength === '10') {
      if (this.router.url.split('/')[2] === 'windspeed') {
        for (let i = 0; i < 28; ++i) {
          if (i === this.blockNum) {
            this.activeRadioList.push(true);
          } else {
            this.activeRadioList.push(false);
          }
        }
      } else if (this.router.url.split('/')[2] === 'rainfall' || this.router.url.split('/')[2] === 'temperature' ||
        this.router.url.split('/')[2] === 'humidity') {
        for (let i = 0; i < 7; ++i) {
          if (i === this.blockNum) {
            this.activeRadioList.push(true);
          } else {
            this.activeRadioList.push(false);
          }
        }
      }
    }
    const deterministicEnsembleSubscription = this.utils.getDeterministicOrEnsemble().subscribe(type => {
      this.detEnsmbl = type;
    });
    this.utils.getmeanMedian().subscribe(type => {
      this.meanMedian = type;
    });
    deterministicEnsembleSubscription.unsubscribe();
  }


  ngOnDestroy() {
    // this.detEnsmblToggle('deterministic');
    this.forecastLengthSubscription.unsubscribe();
    this.blockArraySubscription.unsubscribe();
    this.sourceListSubscription.unsubscribe();
  }

  ngOnChanges(change: SimpleChanges) {
    if (change.blockNum) {
      this.buttonClicked(change.blockNum.currentValue);
    }
    const len = this.activeRadioList.length;
    this.activeRadioList = [];
    for (let i = 0; i < len; ++i) {
      if (i === this.blockNum) {
        this.activeRadioList.push(true);
      } else {
        this.activeRadioList.push(false);
      }
    }
  }

  // showLayer(blockNumber) {
  //   this.blockArraySubscription = this.utils.getBlocksArray().subscribe(value => {
  //     if(this.router.url.split('/')[2] != 'seamlessrainfall') {
  //       this.six_hour_blocks = value;
  //       this.utils.setIndex(this.labelStrings[blockNumber]['groupName']);
  //       this.utils.getSRLRToggle().subscribe(value => {
  //         if (value === true) {
  //           this.utils.setTimestamp(ProjConstants.INDEX_TO_TIMESTAMP_MAPPING[blockNumber.toString()]);
  //         } else {
  //           this.utils.setTimestamp(ProjConstants.INDEX_TO_TIMESTAMP_MAPPING_LR[blockNumber.toString()]);
  //         }
  //       });
  //     }
  //   });
  // }

  showLayer(blockNumber) {
    this.blockArraySubscription = this.utils.getBlocksArray().subscribe(value => {
      if (this.router.url.split('/')[2] !== 'seamlessrainfall') {
        this.six_hour_blocks = value;
        if (this.labelStrings[blockNumber]) {
          this.utils.setIndex(this.labelStrings[blockNumber]['groupName']);
          this.utils.getSRLRToggle().subscribe(value => {
            const timestampMapping = value
              ? ProjConstants.INDEX_TO_TIMESTAMP_MAPPING
              : ProjConstants.INDEX_TO_TIMESTAMP_MAPPING_LR;
            this.utils.setTimestamp(timestampMapping[blockNumber.toString()]);
          });
        }
      }
    });
  }




  imdEcmwfOption(value) {
    this.selectedvalue = value;
    this.utils.setImdEcmwf(this.selectedvalue);
  }

  adminBasinToggle() {
    this.adminSelected = !this.adminSelected;
    this.utils.setAdminBasinToggle(this.adminSelected);
  }

  buttonClicked(index, from?: string) {
    if (from === 'HTML') {
      this.posNum.emit(index);
    }
    this.showLayer(index);
  }

  minMaxToggle(index) {
    // console.log(index);
    this.minMax = index;
    this.utils.minMax.next(this.minMax);
  }

  shortRangeLongRangeToggle() {
    this.imdSRLR = !this.imdSRLR;
    this.utils.setSRLRToggle(this.imdSRLR);
  }

  createlabelStrings() {
    if (this.forecastLength == '24') {
      this.timeStampList = this.utils.get24HrsTimeStamps();
      for (const index in this.timeStampList) {
        if (index == '4') {
          this.labelStrings[index] = { 'label': '24hr', 'groupName': '24hr' };
        } else {
          this.labelStrings[index] = { 'label': this.convertTimestampToBlockValue(this.timeStampList[index]).toString(), 'groupName': this.timeStampList[index].toString() };
        }
      }
    } else if (this.forecastLength == '10') {
      this.timeStampList = this.utils.get10DaysTimeStamps();
      for (const index in this.timeStampList) {
        this.labelStrings[index] = { 'label': this.convertTimestampToBlockValue(this.timeStampList[index]).toString(), 'groupName': this.timeStampList[index].toString() };
      }
    }
  }

  convertTimestampToBlockValue(ts) {
    ts = Number(ts);
    if (this.forecastLength == '24') {
      let starthours = new Date(ts).getHours();
      const startminutes = new Date(ts).getMinutes();
      let startamPm = 'A.M';
      if (starthours > 12) {
        starthours = starthours - 12;
        startamPm = 'P.M';
      }
      let endhours = new Date(ts + ProjConstants.MILLIS_IN_6HOURS).getHours();
      const endminutes = new Date(ts + ProjConstants.MILLIS_IN_6HOURS).getMinutes();
      let endamPm = 'A.M';
      if (endhours > 12) {
        endhours = endhours - 12;
        endamPm = 'P.M';
      }
      return starthours.toString() + ':' + startminutes.toString() + ' ' + startamPm + ' - ' + endhours.toString() + ':' + endminutes.toString() + ' ' + endamPm;
    } else if (this.forecastLength == '10') {
      const date = new Date(ts).toLocaleDateString();
      return date;
    } else {
      return ts;
    }
  }

  validate(i) {
    // let hoursIncrement = ProjConstants.SOURCE_TIMESTAMP_DIFF.IMD;
    if (this.labelStrings[i] == undefined || this.labelStrings[i] == null) {
      return '';
    } else {
      // if(this.forecastLength == '24' && this.selectedvalue =='IMD' && this.labelStrings[i]['groupName']!='24hr'){
      //   return this.convertTimestampToBlockValue(Number(this.labelStrings[i]['groupName'])+hoursIncrement)
      // }else{
        return this.labelStrings[i]['fullLabel'];
      // }
    }
  }
  rainFallActualToggle(i) {
    if (i == 'actual') {
      const url = '/extremeweather/' + this.selected + '-actual/' + this.forecastLength + '/' + this.stateUrlId;
      this.router.navigateByUrl(url);
    }
  }

  detEnsmblToggle(type: string) {
    this.detEnsmbl = type;
    this.utils.setDetermisnisticOrEnsemble(type);
  }

  reloadFunction() {
    /* Scince wer moving the IMD block from 5:30 AM to 8:30 AM and rest of the corresponding block.
    wer doing it by declaring a hoursIncrement variable to 0 and if the selected Source is equla to IMD
    then change the value of hoursIncrement to 3 hours in milliseconds
    you can find all the correspoding changes by searching the term '33435 IMD Block' (in VS Code).
    */

    let hoursIncrement = 0;
    if (this.selectedvalue == 'IMD') {
      hoursIncrement = ProjConstants.SOURCE_TIMESTAMP_DIFF.IMD;
    }

    const tsArray = this.windService.get24HrsTimeStamps(this.selectedvalue);
    const curTimeStamp = new Date().getTime();
    const curInterval = tsArray[1]['timeStamp'] - curTimeStamp + hoursIncrement;
    setTimeout(() => {
      window.location.reload();
    }, curInterval);
  }

  meanMedianlToggle(type: string) {
    this.meanMedian = type;
    this.utils.setmeanMedian(type);
  }

  updateSourceDropDown(){
    let sourceDropDown = []
    for(let index in this.sourceList){
      let sourceInfo = this.sourceList[index];
      if(sourceInfo['forecastLengthList'].indexOf(this.forecastLength) > -1){
        sourceDropDown.push(sourceInfo['source'])
      }
    }
    this.utils.setSourceList(sourceDropDown);
    this.sourceDropdown = sourceDropDown;
  }

  // updateSourceSelected(){
  //   let sourceDropDown = []
  //   for(let index in this.sourceList){
  //     let sourceInfo = this.sourceList[index];
  //     if(sourceInfo['forecastLengthList'].indexOf(this.forecastLength) > -1){
  //       this.selected = sourceInfo['source']
  //       return;
  //     }
  //   }
  // }
}
